/**
 * @fileoverview Barrel exports for the storyline-extraction-pipeline-v1 COMPOSITE agent.
 *
 * This composite orchestrates:
 * - a-storyline-extractor-v1 (sequential, A-Story with thorough beats)
 * - b-storyline-extractor-v1 (parallel, emotional/relational subplots)
 * - c-storyline-extractor-v1 (parallel, tangential storylines)
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Orchestration logic (A sequential → B+C parallel → merge)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow } from './flow';

